// extracted by mini-css-extract-plugin
module.exports = {"panelHeight":"booking-summary_panelHeight__3zN3m"};